/**
 * ============================================================================
 * LOGIN SLIDE-IN PANEL
 * ============================================================================
 *
 * Functionaliteit:
 * - Open/close login panel met smooth animatie
 * - Close bij klik op overlay
 * - Close bij Escape toets
 * - Body scroll lock wanneer panel open is
 */

class LoginPanel {
  constructor() {
    this.panel = document.getElementById('login-panel');
    this.trigger = document.getElementById('login-panel-trigger');
    this.closeBtn = document.getElementById('login-panel-close');
    this.overlay = document.getElementById('login-panel-overlay');

    if (!this.panel || !this.trigger) return;

    this.init();
  }

  init() {
    // Open panel
    this.trigger.addEventListener('click', () => {
      this.open();
    });

    // Close panel - close button
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => {
        this.close();
      });
    }

    // Close panel - overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        this.close();
      });
    }

    // Close panel - Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });
  }

  open() {
    this.panel.setAttribute('aria-hidden', 'false');
    this.panel.classList.add('active');
    this.trigger.setAttribute('aria-expanded', 'true');

    // Show overlay
    if (this.overlay) {
      this.overlay.classList.add('active');
    }

    // Lock body scroll
    document.body.style.overflow = 'hidden';

    // Focus first input
    setTimeout(() => {
      const firstInput = this.panel.querySelector('input[type="email"]');
      if (firstInput) {
        firstInput.focus();
      }
    }, 400);
  }

  close() {
    this.panel.setAttribute('aria-hidden', 'true');
    this.panel.classList.remove('active');
    this.trigger.setAttribute('aria-expanded', 'false');

    // Hide overlay
    if (this.overlay) {
      this.overlay.classList.remove('active');
    }

    // Unlock body scroll
    document.body.style.overflow = '';
  }

  isOpen() {
    return this.panel.getAttribute('aria-hidden') === 'false';
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new LoginPanel();
  });
} else {
  new LoginPanel();
}
